import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <center>
      <h2>{`Contact`}</h2>
      <p />
      <table style={{
        "marginLeft": "auto",
        "marginRight": "auto",
        "borderCollapse": "collapse"
      }}>
	<tr>
		<td><b>Address:&nbsp;&nbsp;</b></td>
		<td style={{
            "borderLeft": "1px solid white"
          }}>Haaksbergerstraat 84-11, 7513 EA, Enschede</td>
	</tr>					
	<tr>
		<td><b>Phone:</b></td>
		<td style={{
            "borderLeft": "1px solid white"
          }}>+48 533 637 633</td>
	</tr>
	<tr>
		<td><b>E-mail:</b></td>
		<td style={{
            "borderLeft": "1px solid white"
          }}>alfonsojim1897@gmail.com</td>
	</tr>
      </table>
      <p />	
      <a href="https://www.linkedin.com/in/alfonso-jimenez1897/"><img src="https://alfonso-jim.github.io/img/linkedin.jpg" style={{
          "maxWidth": "10%",
          "paddingBottom": "4em"
        }} /></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://github.com/Alfonso-Jim"><img src="https://alfonso-jim.github.io/img/git.png" style={{
          "maxWidth": "10%",
          "paddingBottom": "4em"
        }} /></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://alfonso-jim.github.io/resume.pdf"><img src="https://alfonso-jim.github.io/img/resume.png" style={{
          "maxWidth": "10%",
          "paddingBottom": "4em"
        }} /></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="http://ponchojim.com/"><img src="https://alfonso-jim.github.io/img/blog.png" style={{
          "maxWidth": "10%",
          "paddingBottom": "4em"
        }} /></a>
      <div style={{
        "paddingBottom": "15em"
      }}></div>
    </center>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      